module.exports = __webpack_public_path__ + "static/media/fullscreen-close.b5901811.svg";